var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"q-result"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("您的答卷已经提交，感谢您的参与！")]),_c('van-button',{staticClass:"back-home",attrs:{"type":"info","size":"small"},on:{"click":_vm.backHome}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }